/* eslint-disable no-return-assign */
/* eslint-disable no-param-reassign */
const downloadCustomReportQuery = ({
  filter, currentPage = 1, perPage = 10, url, exportFormat = 1,
}) => {
  // Transform keys to capitalize first letter
  const transformParamsKeys = Object.entries(filter).reduce(
    (prev, current) => ({
      ...prev,
      [current[0].charAt(0).toUpperCase() + current[0].substr(1)]: current[1],
    }),
    {},
  )

  // Filter out empty or null values
  const filterParams = Object.entries(transformParamsKeys).reduce(
    (memo, [key, value]) => (
      (value === '' || value === null) ? memo : (memo[key] = value, memo)
    ),
    {},
  )

  // Always include exportFormat in params
  filterParams.FileExportFormat = exportFormat

  // Build query string
  const params = new URLSearchParams(filterParams).toString()
  let searchURL = ''
  if (!Object.keys(filterParams).length) {
    searchURL = `${url}?PageNumber=${currentPage}&PageSize=${perPage}`
  } else if (currentPage !== '' || null) {
    searchURL = `${url}?PageNumber=${currentPage}&PageSize=${perPage}&${params}`
  } else {
    searchURL = `${url}?${params}`
  }

  return searchURL
}

export default downloadCustomReportQuery
